Vendd.Scripts.load(function () {

    var $form = $('.x-registration-b2b-form'), form, formData;

    if ($form.length < 1) return;

    form = $form.get(0);

    //get verification token
    var token = getQueryStringValueByName("vtoken");
    if (token.length > 0) {
        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-content', $form).hide();
        $('.js-success', $form).show();
        $('.js-need-verification', $form).hide();

        //clear user model
        Vendd.User.ClearClientModel();
        //redirect
        window.location = '/';
    }

    importEmailForRegistration();

    formData = {
        companyName: "",
        occupation: "",
        taxAgency: $('select[name="taxAgency"]').val() || "",
        taxIdentifier: "",
        officerName: "",
        vatstatus: 0,
        email: $('input[name="email"]').val().trim() || "",
        emailConfirmation: "",
        username: "",

        town: "",
        address: "",
        number: "",
        postalCode: "",
        phone: "",
        password: "",
        passwordConfirmation: "",

        storesNumber: "",
        phoneTwo: "",
        mobile: "",
        socialSecurityNumber: "",
        fax: "",
        siteUrl: "",
        message: "",

        newsletter: false,
        reCaptchaCode: "",
        redirectUrl: $form.data('redirect') || "",
        acceptTerms: false,

        store: "",
        CompanyCategory: "",
        OpeningHours: "",
        area: $('select[name="area"]').val() || "",
        prefecture: "",
        ReceiveEinvoice: null,
        officerLastName: "",
        officerPosition: "",

        countryCode: $('select[name="countryCode"]').val() || LhApp.Context.Country,

        registrationSetData: registrationSetData || null
    };

    var useEmailAsLoginName = $form.data('useemailasloginname').toString().toLowerCase() === 'true';
    var areaAutoCompleteEnabled = $form.data('areaautocomplete').toString().toLowerCase() === 'true';
    var invoiceAutoCompleteEnabled = $form.data('invoiceautocomplete').toString().toLowerCase() === 'true';
    var uniqueTaxIdEnabled = $form.data('uniquetaxidentifier').toString().toLowerCase() === 'true';
    var verifyemail = $form.data('verifyemail').toString().toLowerCase() === 'true';

    var areaLabel = $form.data('arealabel');
    var areas = [];
    var selectedCountry = $('.js-countries-selector option:selected', $form);
    var areasCount = selectedCountry.length > 0 ? selectedCountry.data('areascount') : 0;
    var isEUCountry = selectedCountry.length > 0 ? selectedCountry.data('eucountry').toString().toLowerCase() === 'true' : false;
    var initialAjaxCall = true;
    var registrationSetData = [];

    var vatInfoModel = null, uniqueTaxIdModel = null;

    // reCAPTCHA
    var captchaWidgetId;
    var captchaId = "registrationCaptcha";
    var $captchaElement = $form.find("#" + captchaId);
    var $captchaContainer = $form.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;

    form.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': form.recaptchaCallback
            });
        }
    };

    form.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.recaptcha-required').removeClass('error');
            res = true;
        }
        else {
            $captchaContainer.find('.recaptcha-required').addClass('error');
        }

        return res;
    };

    form.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once.
        // If a verify attempt has been made with a particular token, it cannot be used again.
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    form.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    form.recaptchaCallback = function () {
        form.validateRecaptcha();
    };

    form.getAreasForPostCode = function (envelope) {

        areas = envelope ? envelope.message.data : [];

        var html = Vendd.Handlebars.parse("registrationB2BArea_A", areas);
        $('.form-row.area .js-area-wrapper').html(html);

        //add new validation for area select
        var valOptArea = { area: { required: 'area-required' } };
        rf.removeField("area");
        rf.addField(valOptArea);

        if (areas.length < 1) {
            $('.form-row.area').removeClass('select');
            $('.form-row.area label').empty().append(areaLabel);

        } else {
            $('.form-row.area').addClass('select');

            //submit value in formData
            if (areas.length === 1) {
                formData.area = areas[0].Name;
                rf.validate("area");
            }

            if (areas.length > 0) {
                //if City exists, submit the value in formData
                if (areas[0].City.length > 0 && $('input[name="town"]:text').length > 0) {
                    $('input[name="town"]:text').val(areas[0].City);
                    formData.town = areas[0].City;
                }

                //if Prefecture exists, submit the value in formData
                if (areas[0].Prefecture.Name.length > 0 && $('input[name="prefecture"]').length > 0) {
                    $('input[name="prefecture"]').val(areas[0].Prefecture.Name);
                    formData.prefecture = areas[0].Prefecture.Name;
                }
            }
        }

        //validate postal code
        if (areaAutoCompleteEnabled && areasCount > 1)
            valOpts.postalCode.isValidPostalCode.config.areas = areas;
    };

    form.updatePostalCode = function (countryCode) {
        //delete validations related to country
        if (valOpts.postalCode && valOpts.postalCode.isValidPostalCode)
            delete valOpts.postalCode.isValidPostalCode;

        selectedCountry = $('.js-countries-selector option:selected', $form);
        areasCount = selectedCountry.length > 0 ? selectedCountry.data('areascount') : 0;

        //add validation
        if (areaAutoCompleteEnabled && areasCount > 1) {
            valOpts.postalCode = valOpts.postalCode || {};
            valOpts.postalCode = { ...valOpts.postalCode, ...{ isValidPostalCode: { validator: 'postalCode-invalid', config: { country: countryCode, areas: areas } } } };
        }
            
        //update validation field
        if (valOpts.postalCode) {
            var valOptPostalCode = { postalCode: valOpts.postalCode };
            rf.removeField("postalCode");
            rf.addField(valOptPostalCode);
        }
    };

    form.einvoiceValidation = function () {
        var checkedValue = '';

        $.each($('input[name="einvoice"]', $form), function (e, el) {
            if ($(el).is(":checked")) {
                checkedValue = $(el).val();
            }
        });

        if (checkedValue === 'true' || checkedValue === 'false') {
            $('.form-row.einvoice', $form).removeClass('with-error');
            $('.validator.einvoice-required', $form).removeClass('error');
            return true;
        } else {
            $('.form-row.einvoice', $form).addClass('with-error');
            $('.validator.einvoice-required', $form).addClass('error');
            return false;
        }
    }

    form.setRegistrationData = function () {

        var $sets = $('.js-registration-set', $form);

        if ($sets.length < 1) return;

        //init array
        registrationSetData = [];

        $.each($sets, function (e, set) {
            var $set = $(set);

            var setData = {
                Name: $set.data('set-name'),
                Id: $set.data('set-id'),
                Values: []
            }

            $.each($('input[type="checkbox"]', $set), function (e, input) {
                if ($(input).is(':checked')) {
                    var setValues = {
                        Id: $(input).data('id'),
                        Name: $(input).data('name')
                    }

                    setData.Values.push(setValues);
                }
            });

            if (setData.Values.length > 0)
                registrationSetData.push(setData);
        });

        if (registrationSetData.length > 0)
            formData.registrationSetData = registrationSetData;
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;

        if (response.success && response.code === "Registration_OperationSuccesful") {
            //insert consents after registration success
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            }

            $('.js-error', $form).hide();
            $('.js-exists', $form).hide();
            $('.js-content', $form).hide();
            $('.js-need-verification', $form).hide();
            $('.js-success', $form).hide();

            if (verifyemail) {
                $('.js-need-verification', $form).show();
            } else {
                $('.js-success', $form).show();
            }

            $('html,body').animate({ scrollTop: 0 }, 300);

            form.removeRecaptcha();

            /* Track User Registration */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'CompleteRegistration');
                }
            }
            /* END Track User Registration */

        } else {

            if (response.code === 'Registration_EmailExists') {
                $('.js-error', $form).hide();
                $('.js-exists', $form).show();
                $('html,body').animate({ scrollTop: $('.js-exists', $form).offset().top - 100 }, 300);
            } else {
                $('.js-exists', $form).hide();
                $('.js-error', $form).show();
                $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);
            }

            form.resetRecaptcha();
        }
    };

    form.onFailure = function (envelope) {
        form.hideLoader();

        var response = envelope.message.data;
        if (response === 'Registration_EmailExists') {
            $('.js-error', $form).hide();
            $('.js-exists', $form).show();
            $('html,body').animate({ scrollTop: $('.js-exists', $form).offset().top - 100 }, 300);
        } else {
            $('.js-exists', $form).hide();
            $('.js-error', $form).show();
            $('html,body').animate({ scrollTop: $('.js-error', $form).offset().top - 100 }, 300);
        }

        form.resetRecaptcha();
    };

    form.submit = function () {
        form.loading(true);

        formData.vatstatus = $('select[name="vatstatus"]').val();
        formData.newsletter = $('#chkNewsletter').prop("checked");

        var einvoiceVal = $("input:radio[name='einvoice']:checked").val();

        if (einvoiceVal === "true") {
            formData.ReceiveEinvoice = true;
        } else if (einvoiceVal === "false") {
            formData.ReceiveEinvoice = false;
        } else {
            formData.ReceiveEinvoice = null;
        }

        form.setRegistrationData();

        $('input:not([type="checkbox"]), textarea:not([name="g-recaptcha-response"]), select', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).attr('name') === 'email' ? $(this).val().trim() : $(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.B2BRegister(
            formData.companyName,
            formData.occupation,
            formData.taxAgency,
            formData.taxIdentifier,
            formData.officerName,
            formData.vatstatus,
            formData.email,
            formData.emailConfirmation,
            formData.username,
            formData.town,
            formData.address,
            formData.number,
            formData.postalCode,
            formData.phone,
            formData.password,
            formData.passwordConfirmation,
            formData.storesNumber,
            formData.phoneTwo,
            formData.mobile,
            formData.socialSecurityNumber,
            formData.fax,
            formData.siteUrl,
            formData.store,
            formData.CompanyCategory,
            formData.OpeningHours,
            formData.area,
            formData.prefecture,
            formData.officerLastName,
            formData.officerPosition,
            formData.message,
            formData.newsletter,
            formData.ReceiveEinvoice,
            formData.reCaptchaCode,
            formData.redirectUrl,
            formData.countryCode,
            formData.registrationSetData));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-exists', $form).hide();
        $('.js-success', $form).hide();
        $('.js-need-verification', $form).hide();
        $('.js-content', $form).show();

        $('input[name="companyName"]', $form).val("");
        $('input[name="occupation"]', $form).val("");
        $('input[name="taxAgency"]', $form).val("");
        $('input[name="taxIdentifier"]', $form).val("");
        $('input[name="officerName"]', $form).val("");
        $('input[name="vatstatus"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="emailConfirmation"]', $form).val("");
        $('input[name="username"]', $form).val("");
        $('input[name="town"]', $form).val("");
        $('input[name="address"]', $form).val("");
        $('input[name="number"]', $form).val("");
        $('input[name="postalCode"]', $form).val("");

        $('input[name="phone"]', $form).val("");
        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");
        $('select[name="storesNumber"]', $form).val("");
        $('input[name="phoneTwo"]', $form).val("");
        $('input[name="mobile"]', $form).val("");
        $('input[name="socialSecurityNumber"]', $form).val("");

        $('input[name="fax"]', $form).val("");
        $('input[name="siteUrl"]', $form).val("");
        $('input[name="message"]', $form).val("");
        $('input[name="store"]', $form).val("");
        $('input[name="CompanyCategory"]', $form).val("");
        $('input[name="OpeningHours"]', $form).val("");
        $('input[name="area"]', $form).val("");
        $('select[name="area"]', $form).val("");
        $('input[name="prefecture"]', $form).val("");

        $('input[name="officerLastName"]', $form).val("");
        $('input[name="officerPosition"]', $form).val("");

        rf.reset();
    };

    form.resetAddressFields = function () {

        $('input[name="address"]', $form).val("");
        $('input[name="number"]', $form).val("");
        $('input[name="postalCode"]', $form).val("");
        $('input[name="town"]', $form).val("");
        $('input[name="area"]', $form).val("");
        $('select[name="area"]', $form).val("");
        $('input[name="prefecture"]', $form).val("");

        form.getAreasForPostCode();

    };

    form.updatePasswordBar = function (field) {
        var value = field.val();
        var score = Vendd.Helpers.textStrength(value);

        var $passwordStrength = $('#chkPassLabel, #chkPassText');

        $passwordStrength.removeClass(function (i, css) {
            return (css.match(/(^|\s)level\S+/g) || []).join(' ');
        }).addClass('level' + score); 
    };

    $.fn.validationEngine.validations.passwordStrength = Vendd.Validations.passwordStrength;


    //init validation options
    var valOpts = {}, initialValidation = false;

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        valOpts[inputName] = { required: inputName + '-required' };
    });

    //add consent validations
    $.each($('.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el).attr('name');
        valOpts[consentType] = { checkboxRequired: consentType + '-required' };
    });

    //add AFM validation only if config parameter is true
    if (venddProjectConfigs.TaxIdentifierValidationEnabled && $('input[name="taxIdentifier"]', $form).length > 0) {
        valOpts.taxIdentifier = valOpts.taxIdentifier || {};
        if (invoiceAutoCompleteEnabled && isEUCountry) {
            valOpts.taxIdentifier = { ...valOpts.taxIdentifier, ...{ isServiceValidTaxIdentifier: { validator: 'taxIdentifier-invalid', config: { isValid: true } } } };
        } else {
            if (formData.countryCode === "GR")
                valOpts.taxIdentifier = { ...valOpts.taxIdentifier, ...{ isGreekTaxIdentifier: 'taxIdentifier-invalid' } };
        }

        if (uniqueTaxIdEnabled)
            valOpts.taxIdentifier = { ...valOpts.taxIdentifier, ...{ isUniqueTaxIdentifier: { validator: 'taxIdentifier-exists', config: { isUnique: true } } } };        
    }

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        valOpts.email = valOpts.email || {};
        valOpts.email = { ...valOpts.email, ...{ isEmail: 'email-invalid' } };
    }

    //add email confirmation validation
    if ($('input[name="emailConfirmation"]', $form).length > 0) {
        valOpts.emailConfirmation = valOpts.emailConfirmation || {};
        valOpts.emailConfirmation = { ...valOpts.emailConfirmation, ...{ isEmail: 'emailConfirmation-invalid', match: { validator: 'emailConfirmation-match', matchField: 'email' } } };
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        valOpts.phone = valOpts.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            valOpts.phone = { ...valOpts.phone, ...{ isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } } };
        } else {
            if (venddProjectConfigs.Account.RegexPhoneValidation) {
                valOpts.phone = { ...valOpts.phone, ...{ isRegexPhone: { validator: 'phone-invalid', config: { regex: venddProjectConfigs.Account.RegexPhoneValue } } } };
            } else {
                valOpts.phone = { ...valOpts.phone, ...{ isPhoneNumber: 'phone-invalid' } };
            }
        }
    }

    //add mobile validation
    if ($('input[name="mobile"]', $form).length > 0) {
        valOpts.mobile = valOpts.mobile || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            valOpts.mobile = { ...valOpts.mobile, ...{ isValidPhoneLocalized: { validator: 'mobile-invalid', config: { type: 'mobile' } } } };
        } else {
            if (venddProjectConfigs.Account.RegexMobileValidation) {
                valOpts.mobile = { ...valOpts.mobile, ...{ isRegexMobile: { validator: 'mobile-invalid', config: { regex: venddProjectConfigs.Account.RegexMobileValue } } } };
            } else {
                valOpts.mobile = { ...valOpts.mobile, ...{ isPhoneNumber: 'mobile-invalid' } };
            }
        }
    }

    //add password strength validation
    if ($('input[name="password"]', $form).length > 0) {
        valOpts.password = valOpts.password || {};
        valOpts.password = { ...valOpts.password, ...{ passwordStrength: { validator: 'password-weak', config: { limit: $form.data('pwdstrength') } } } };
    }

    //add confirmation password match validation
    if ($('input[name="passwordConfirmation"]', $form).length > 0) {
        valOpts.passwordConfirmation = valOpts.passwordConfirmation || {};
        valOpts.passwordConfirmation = { ...valOpts.passwordConfirmation, ...{ match: { validator: 'passwordConfirmation-match', matchField: 'password' } } };
    }

    //add social security number validation
    if ($('input[name="socialSecurityNumber"]', $form).length > 0) {
        valOpts.socialSecurityNumber = { isSocialSecurityNumber: 'socialSecurityNumber-invalid' };
    }
    
    //add postalCode validation only if config parameter is true and selected country has areas
    if (areaAutoCompleteEnabled && areasCount > 1) {
        valOpts.postalCode = valOpts.postalCode || {};
        valOpts.postalCode = { ...valOpts.postalCode, ...{ isValidPostalCode: { validator: 'postalCode-invalid', config: { country: formData.countryCode, areas: areas } } } };
    }

    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');

    $.each($('.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el);
        consentType.on('change', function () {
            rf.validate(consentType.attr('name'));
        });
    });

    $form.on('click', '.js-submit-button', function (e) {

        e.preventDefault();
        e.stopPropagation();

        var val1 = form.validateRecaptcha();
        var val2 = rf.validate();
        var val3 = form.einvoiceValidation();

        if (val1 && val2 && val3) {
            form.submit();
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({ scrollTop: $('.form-row.with-error', $form).first().offset().top - 100 }, 600);
            }
        }

        initialValidation = true;
    });

    form.checkConsents = function () {
        var data = [];
        var checkboxes = $('.form-row.consent.checkbox', $form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Registration Form', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        }
    };

    $form.on('click', '.js-password-reveal', function (e) {
        e.preventDefault();
        if ($(this).hasClass('shown')) {
            $(this).removeClass('shown').siblings('input').prop('type', 'password');
        } else {
            $(this).addClass('shown').siblings('input').prop('type', 'text');
        }
    });

    $form.on('change', 'select[name]', function (e) {
        //update validation for postal code
        if ($(this).attr('name') === "countryCode") {

            var countryCode = $(this).val();

            if (countryCode === formData.countryCode) return;

            form.resetAddressFields();
            form.updatePostalCode(countryCode);

        }

        form.setField($(this));
    });

    $form.on('change', 'input[name="einvoice"]', function (e) {
        if ($('.form-row.einvoice', $form).hasClass('with-error')) {
            $('.form-row.einvoice', $form).removeClass('with-error');
            $('.validator.einvoice-required', $form).removeClass('error');
        }
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        //if (e.keyCode === 13) {
        //    e.preventDefault();
        //    e.stopPropagation();

        //    $('.js-submit-button', $form).click();

        //    return;
        //}

        if ($(this).attr('name') === "postalCode") {
            removeWhiteSpaces($(this));
        }

        if ($(this).attr('name') === "password") {
            form.updatePasswordBar($(this));
            rf.validate("passwordConfirmation");
        }

        form.setField($(this));
    });

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        if ($(this).attr('name') === "password") {
            form.updatePasswordBar($(this));
            rf.validate("passwordConfirmation");
        }

        //validate fields instantly
        if (!initialValidation) {
            if ($(this).attr('name') === "email") {
                rf.validateField("email");
            }

            if ($(this).attr('name') === "phone") {
                rf.validateField("phone");
            }

            if ($(this).attr('name') === "mobile") {
                rf.validateField("mobile");
            }
        }

        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        formData[fieldName] = (fieldName === 'email' || fieldName === 'emailConfirmation') ? field.val().trim() : field.val();
        rf.validate(fieldName);
    };

    form.addTaxIdentifierValidation = function () {
        if (!vatInfoModel && invoiceAutoCompleteEnabled && isEUCountry)
            return;

        if (!uniqueTaxIdModel && uniqueTaxIdEnabled)
            return;

        rf.removeField("taxIdentifier");

        rf.addField({ taxIdentifier: valOpts.taxIdentifier });

        rf.validateField('taxIdentifier');
    };

    if (areaAutoCompleteEnabled) {
        $form.on('keyup', 'input[name="postalCode"]', $.debounce(400, function () {
            var $this = $(this);
            var postalCode = $this.val();

            if (postalCode.length > 0 && areasCount > 1)
                Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetAreasForPostCode(formData.countryCode, postalCode, ""));
        }));

        $form.on('focus', 'input[name="area"]', function (e) {
            e.preventDefault();

            if (areasCount > 1)
                $('input[name="postalCode"]', $form).focus();
        });
    }
    
    if (invoiceAutoCompleteEnabled || uniqueTaxIdEnabled) {
        $form.on('keyup', 'input[name = "taxIdentifier"]', $.debounce(400, function () {
            var $this = $(this);
            var taxIdentifier = $this.val();

            if (taxIdentifier == null || taxIdentifier == '') {
                rf.validateField('taxIdentifier');
                return;
            }

            //omit script tag before ajax call
            taxIdentifier = omitScriptTag(taxIdentifier);

            if (invoiceAutoCompleteEnabled && isEUCountry) {
                vatInfoModel = null;
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetVatInfo(selectedCountry.val(), taxIdentifier));
            }

            if (uniqueTaxIdEnabled) {
                uniqueTaxIdModel = null;
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.UniqueTaxIdentifierExists(selectedCountry.val(), taxIdentifier));
            }              
        }));  
    }

    if (invoiceAutoCompleteEnabled) {
        $form.on('change', 'select[name = "countryCode"]', function (e) {
            //update isEUCountry parameter
            isEUCountry = $(this).find('option:selected').data('eucountry').toString().toLowerCase() === 'true';

            //call service for taxAgencies
            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllTaxAgencies(formData.countryCode));
        });
    }

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="phone"]', $form).length > 0) {
            $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.phone = $(this).val();
                rf = $form.data('validationEngine');
                rf.validate('phone');
            });
        }
        if ($('input[name="mobile"]', $form).length > 0) {
            $('input[name="mobile"]', $form).get(0).addEventListener("countrychange", function () {
                formData.mobile = $(this).val();
                rf = $form.data('validationEngine');
                rf.validate('mobile');
            });
        }
    }

    $(".view-terms").fancybox({
        touch: false
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegisterSuccess, form, form.onSuccess);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegisterFailure, form, form.onFailure);

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, form, form.initRecaptcha);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetAreasForPostCodeSuccess, form, form.getAreasForPostCode);

    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllTaxAgencies(formData.countryCode));

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllTaxAgenciesSuccess, form, function (envelope) {
        var taxAgencies = envelope.message.data.model;
        var $taxAgenciesWrapper = $(".js-tax-agencies-select", $form);
        var literalsModel = { TaxAgency: $taxAgenciesWrapper.data('literal') };

        if (taxAgencies.length > 0) {
            var taxAgenciesHtml = Vendd.Handlebars.parse("accountTaxAgencyCombo_A", taxAgencies);
        } else {
            var data = {};
            data.Literals = literalsModel;
            var taxAgenciesHtml = Vendd.Handlebars.parse("accountTaxAgencyCombo_A", data);
        }

        $taxAgenciesWrapper.html(taxAgenciesHtml);

        //re-init validation after html parse
        rf.removeField("taxAgency");
        rf.addField({ taxAgency: { required: 'taxAgency-required' } });

        //validate again taxAgency if fields area already validated
        if (initialValidation)
            rf.validateField("taxAgency");

        //ajax call for Vat Info Service
        if (!initialAjaxCall)
            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetVatInfo(selectedCountry.val(), formData.taxIdentifier));

        initialAjaxCall = false;
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetVatInfoSuccess, form, function (envelope) {
        vatInfoModel = envelope.message.data.model;

        if (vatInfoModel.isValid) {
            if (vatInfoModel.name) {
                $('input[name = "companyName"]:text').val(vatInfoModel.name);
                formData.companyName = vatInfoModel.name;
            }
            if (vatInfoModel.occupation) {
                $('input[name = "occupation"]:text').val(vatInfoModel.occupation);
                formData.occupation = vatInfoModel.occupation;
            }
            if (vatInfoModel.taxAgency) {
                if ($('select[name="taxAgency"]').length > 0) {
                    $('select[name="taxAgency"] option[data-code=' + vatInfoModel.taxAgencyCode + ']').prop('selected', true);
                    formData.taxAgency = $('select[name="taxAgency"]').val();
                } else {
                    $('input[name="taxAgency"]').val(data.taxAgency);
                    formData.taxAgency = vatInfoModel.taxAgency;
                }
            }

            valOpts.taxIdentifier.isServiceValidTaxIdentifier.config.isValid = true;

        } else {
            if (vatInfoModel.error && vatInfoModel.error.message) {
                $('.taxidentifier-container .taxIdentifier-invalid', $form).text(vatInfoModel.error.message);
            }

            valOpts.taxIdentifier.isServiceValidTaxIdentifier.config.isValid = false;
        }

        if (venddProjectConfigs.TaxIdentifierValidationEnabled)
            form.addTaxIdentifierValidation();
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetVatInfoFailed, form, function (envelope) {
        vatInfoModel = envelope.message.data;

        valOpts.taxIdentifier.isServiceValidTaxIdentifier.config.isValid = true;

        if (venddProjectConfigs.TaxIdentifierValidationEnabled)
            form.addTaxIdentifierValidation();
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.UniqueTaxIdentifierExistsSuccess, form, function (envelope) {
        uniqueTaxIdModel = envelope.message.data.model;

        valOpts.taxIdentifier.isUniqueTaxIdentifier.config.isUnique = uniqueTaxIdModel.success ? false : true;

        if (venddProjectConfigs.TaxIdentifierValidationEnabled)
            form.addTaxIdentifierValidation();
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.UniqueTaxIdentifierExistsFailed, form, function (envelope) {
        uniqueTaxIdModel = envelope.message.data;

        valOpts.taxIdentifier.isUniqueTaxIdentifier.config.isUnique = false;

        if (venddProjectConfigs.TaxIdentifierValidationEnabled)
            form.addTaxIdentifierValidation();
    });

});